module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-down-circle-e3f14daa.svg";